<template>
  <action-dispatcher
    action="product/getProduct"
    :parameters="$route.params.id"
    @success="checkRoute"
  >
    <page-header>
      <template #custom-header>
        <div class="d-flex flex-column flex-lg-row justify-content-between">
          <product-dropdown :product="product" :dropdown="showDropdown" />
          <!--
          <bp-switch
            v-if="product.type_product === 'onsite_event'"
            class="mt-5"
            label="Desativar evento"
          /> -->

          <action-dispatcher
            small
            action="membersSetup/get"
            :parameters="$route.params.id"
            v-if="product.is_blitz_members"
          >
            <a
              :href="membersURL"
              target="_blank"
              class="members-link d-none d-lg-inline"
            >
              Acessar área de membros
              <i class="fa fa-arrow-up-right-from-square ml-2" />
            </a>
          </action-dispatcher>
        </div>
      </template>
    </page-header>

    <page-container v-if="!$route.meta.aside">
      <router-view />
    </page-container>

    <router-view v-else />
  </action-dispatcher>
</template>

<script>
import ProductDropdown from "@/components/product/ProductDropdown";
import BreadcrumbsMixin from "@/mixins/breadcrumbs";
import { getToken } from "@/setup/api";
import { mapState } from "vuex";

export default {
  mixins: [BreadcrumbsMixin],
  components: { ProductDropdown },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersSetup", ["setup"]),
    membersURL() {
      return `https://${
        this.setup?.subdomain
      }.club.blitzpay.com.br/token?token=${getToken()}`;
    },
    showDropdown() {
      return ["active", "inactive"].includes(this.product?.status);
    }
  },
  methods: {
    checkRoute() {
      if (
        this.product &&
        [
          "product-member-area-comments",
          "product-member-area-groups-edit",
          "product-member-area-groups-add",
          "product-member-area-groups"
        ].includes(this.$route.name) &&
        !["active", "inactive"].includes(this.product.status)
      )
        this.$router.push({
          name: "product-details",
          params: { id: this.$route.params.id }
        });
    }
  },
  mounted() {
    this.checkRoute();
  }
};
</script>
